const AccData = [
    {
      date: "2024-12-01",
      description: "Lottery Entry #123",
      ticketCost: 10,
      winningAmount: 0,
      balance: 90,
    },
    {
      date: "2024-12-02",
      description: "Lottery Entry #124",
      ticketCost: 15,
      winningAmount: 50,
      balance: 125,
    },
    {
      date: "2024-12-03",
      description: "Lottery Entry #125",
      ticketCost: 20,
      winningAmount: 0,
      balance: 105,
    },
  ];
  
  export default AccData;
  